module.exports = __webpack_public_path__ + "img/5734623.png";